import * as Sentry from '@sentry/vue';
export const initSentry = (app) => {
    const config = window.sentryConfig;
    if (!config?.dsn) {
        return;
    }
    Sentry.init({
        app,
        dsn: config.dsn,
        environment: config.environment,
        release: config.release,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: config.tracesSampleRate,
    });
};
